import React, { useCallback } from 'react';
import { confirm } from 'components/atoms/modal';
import { toastService } from 'components/molecules/toast';
import { Member, MembersAPI } from 'data/members/api';
import { useTranslate } from 'hooks/use-translation';

interface Result {
  resendInvite: (member: Member) => void;
}
export const useResendInvitation = (): Result => {
  const translate = useTranslate();
  const resendInvite = useCallback(
    ({ user: { emailId, role }, permissionSet }: Member) => {
      const payload = [
        {
          user: {
            emailId,
            role,
          },
          permissionSet,
        },
      ];

      MembersAPI.inviteMembers(payload)
        .then(() => {
          toastService({
            title: translate('invitation.success.title'),
            message: translate('invitation.success.content'),
          }).success();
        })
        .catch(() => {
          toastService({
            title: translate('failure'),
            message: translate('invitation.resend.confirm.error.content'),
          }).error();
        });
    },
    [translate],
  );
  const confirmResendInvite = useCallback(
    (member: Member) => {
      confirm({
        title: translate('invitation.resend.confirm.title'),
        content: translate('invitation.resend.confirm.content', {
          user: <b>{member.user.emailId}</b>,
        }),
        okText: translate('resend'),
        onOk: () => {
          resendInvite(member);
        },
      });
    },
    [resendInvite, translate],
  );

  return {
    resendInvite: confirmResendInvite,
  };
};
